<template>
  <div>
    <b-jumbotron>
      <b-container>
        <h1 v-label-key="'PASSWORD_RESET'">Password Reset</h1>
        <p v-if="currentUser">
          {{ currentUser.email }}
        </p>
      </b-container>
    </b-jumbotron>
    <b-container class="mt-5">
      <b-row>
        <b-col md="6" offset-md="3">
          <!-- Used when generating a reset token -->
          <div v-if="!currentUser">
            <b-form @submit.prevent="sendResetLink">
              <b-form-group :label="getLabel('EMAIL_ADDRESS')">
                <b-form-input
                  v-model="creds.email"
                  type="email"
                  :placeholder="getLabel('EMAIL_INPUT_PLACEHOLDER')"
                />
              </b-form-group>
              <b-button
                variant="primary"
                type="submit"
                key="sendresetlinkbutton"
              >
                <span v-label-key="'SEND_RESET_LINK'">Send Reset Link</span>
              </b-button>
            </b-form>
          </div>

          <!-- Used when performing a reset using a token -->
          <div v-if="currentUser">
            <b-form @submit.prevent="doPasswordReset">
              <b-form-group :label="getLabel('NEW_PASSWORD')">
                <b-form-input
                  v-model="creds.newPassword"
                  type="password"
                  :placeholder="getLabel('ENTER_PASSWORD')"
                />
              </b-form-group>
              <b-form-group :label="getLabel('CONFIRM_PASSWORD')">
                <b-form-input
                  v-model="creds.newPassword2"
                  type="password"
                  :placeholder="getLabel('ENTER_PASSWORD')"
                />
              </b-form-group>
              <b-button
                variant="primary"
                type="submit"
                key="resetpasswordbutton"
              >
                <span v-label-key="'RESET_PASSWORD'">Reset Password</span>
              </b-button>
            </b-form>
          </div>
        </b-col>
      </b-row>
    </b-container>
  </div>
</template>
<script>
import $api from '@/services/api';
import { mapGetters } from 'vuex';

export default {
  computed: {
    ...mapGetters('translations', {
      getLabel: 'getLabel',
    }),
  },
  data() {
    return {
      currentUser: null,
      creds: {},
      isPasswordMode: false,
    };
  },
  created() {
    if (this.$route.query.uid) {
      this.isPasswordMode = true;
      $api
        .get(`/v1/dashboard/useremail/${this.$route.query.uid}`)
        .then((user) => {
          this.currentUser = user;
        });
    }
  },
  methods: {
    sendResetLink() {
      $api
        .post('/v1/dashboard/passwordresets', this.creds)
        .then(() => {
          alert(this.getLabel('PASSWORD_RESET_LINK_ALERT')); // eslint-disable-line no-alert
        })
        .catch((err) => {
          alert(err); // eslint-disable-line no-alert
        });
    },
    doPasswordReset() {
      if (this.creds.newPassword !== this.creds.newPassword2) {
        alert(this.getLabel('PASSWORD_NO_MATCH_ALERT')); // eslint-disable-line no-alert
      } else {
        const params = {
          uid: this.$route.query.uid,
          password: this.creds.newPassword,
          code: this.$route.query.code,
        };
        $api
          .post('/v1/dashboard/passwordresets', params)
          .then(() => {
            alert(this.getLabel('PASSWORD_RESET_SUCCESS_ALERT')); // eslint-disable-line no-alert
            this.$router.push({
              name: 'login',
            });
          })
          .catch((err) => {
            alert(err); // eslint-disable-line no-alert
          });
      }
    },
  },
};
</script>
